import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';

/**
 * Unauthorized - Shown when user tries to access a route they don't have permission for
 */
const Unauthorized = () => {
  const navigate = useNavigate();
  
  const handleGoBack = () => {
    navigate(-1); // Go back to previous page
  };
  
  const handleGoHome = () => {
    navigate('/'); // Go to home/default dashboard
  };
  
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, rgba(12, 20, 49, 1) 0%, rgba(40, 13, 58, 1) 50%, rgba(16, 61, 62, 1) 100%)',
        color: 'white',
        padding: 4,
        textAlign: 'center'
      }}
    >
      <LockIcon sx={{ fontSize: 80, color: '#ff6b6b', mb: 3 }} />
      
      <Typography variant="h3" sx={{ fontWeight: 600, mb: 2 }}>
        Access Denied
      </Typography>
      
      <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.7)', mb: 4, maxWidth: 600 }}>
        You don't have permission to access this page. Please contact your administrator if you believe this is an error.
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          onClick={handleGoBack}
          sx={{
            color: 'white',
            borderColor: 'rgba(255,255,255,0.3)',
            '&:hover': {
              borderColor: 'white',
              backgroundColor: 'rgba(255,255,255,0.1)'
            }
          }}
        >
          Go Back
        </Button>
        
        <Button
          variant="contained"
          onClick={handleGoHome}
          sx={{
            backgroundColor: '#6366f1',
            '&:hover': {
              backgroundColor: '#4f46e5'
            }
          }}
        >
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default Unauthorized;
